import { useAppSelector } from '~/redux/hooks'
import { selectCurrentSubscriptionId } from '~/redux/slices/subscription.slice'
import { useGetStripeCurrentSubscriptionDetailsQuery } from '~/subscription/apis/subscription.api'
import { StripeSubscription } from '~/subscription/types/subscription.types'
import useCurrentUser from '~/hooks/useCurrentUser'

type SubscriptionType = 'family' | 'individual'

interface UseCurrentSubscriptionResult {
  subscriptionDetails?: StripeSubscription
  subscriptionType?: SubscriptionType
  isLoading: boolean
  error?: any
}

export default function useCurrentSubscription(skip?: boolean): UseCurrentSubscriptionResult {
  const user = useCurrentUser()
  const currentSubscriptionId =
    useAppSelector(selectCurrentSubscriptionId) || user?.stripeSubscription[0]?.subscriptionId

  const {
    data: currSubscription,
    isLoading,
    error,
  } = useGetStripeCurrentSubscriptionDetailsQuery(
    { subscriptionId: currentSubscriptionId },
    { skip: skip || !currentSubscriptionId },
  )

  const subscriptionType: SubscriptionType | undefined = currSubscription?.subscription
    ? (currSubscription.subscription.metadata?.subscriptionType as SubscriptionType) === 'family'
      ? 'family'
      : 'individual'
    : undefined

  return {
    subscriptionDetails: currSubscription?.subscription,
    subscriptionType,
    isLoading,
    error,
  }
}
